"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const GuidesButton_1 = __importDefault(require("../../../atoms/GuidesButton"));
const LabelsOptionsPanel_1 = __importDefault(require("../../../molecules/LabelsOptionsPanel"));
const ToolsMode_1 = __importDefault(require("../../../templates/ToolsMode"));
const providers_1 = require("../../../providers");
const ui_1 = require("@completeanatomy/ui");
const i18n_1 = require("@completeanatomy/i18n");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const react_1 = require("react");
const hooks_1 = require("../../../hooks");
const useOnAddLabel_1 = require("../../../hooks/useOnAddLabel");
const animation_1 = require("../../../utils/animation");
// eslint-disable-next-line max-lines-per-function
function ToolLabelsModePage() {
    var _a, _b;
    const [isUIHidden, toggleUIHidden] = (0, ui_1.useToggleState)(false);
    const [{ isGuidesAvailable, isGuidesExpanded }] = (0, providers_1.useGuidesContext)();
    const latestLabel = (0, hooks_1.useLatestLabel)();
    const labelsState = (0, hooks_1.useLabels)();
    const labels = (0, hooks_1.useLabelState)();
    const tools = (0, providers_1.useToolsService)();
    const labelToolManager = (_a = tools === null || tools === void 0 ? void 0 : tools.getLabelToolManager()) !== null && _a !== void 0 ? _a : null;
    const bridge = (0, bridge_1.useBridge)();
    const selectedLabelID = labelsState === null || labelsState === void 0 ? void 0 : labelsState.selectedLabelID;
    const [isAddingLabels, setIsAddingLabels] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (selectedLabelID) {
            const selectedLabel = labels === null || labels === void 0 ? void 0 : labels.find(label => label.identifier === selectedLabelID);
            if (selectedLabel &&
                selectedLabel.type === bridge_schema_1.LabelType.Group &&
                (selectedToolType === bridge_schema_1.ToolType.LabelsLeft ||
                    selectedToolType === bridge_schema_1.ToolType.LabelsRight)) {
                labelToolManager === null || labelToolManager === void 0 ? void 0 : labelToolManager.setGroupMode();
                bridge === null || bridge === void 0 ? void 0 : bridge.enterLabelGroupMode();
                localStorage.setItem('groupModeID', selectedLabelID);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedLabelID]);
    (0, react_1.useEffect)(() => {
        if ((latestLabel === null || latestLabel === void 0 ? void 0 : latestLabel.type) === bridge_schema_1.LabelType.Group && !labelsState.isGroupMode) {
            labelToolManager === null || labelToolManager === void 0 ? void 0 : labelToolManager.setGroupMode();
            bridge === null || bridge === void 0 ? void 0 : bridge.enterLabelGroupMode();
        }
    }, [bridge, labelToolManager, labelsState.isGroupMode, latestLabel === null || latestLabel === void 0 ? void 0 : latestLabel.type]);
    const isGuidesButtonVisible = isGuidesAvailable && !isGuidesExpanded && !isUIHidden;
    const [selectedToolType, setSelectedToolType] = (0, react_1.useState)(bridge_schema_1.ToolType.LabelsLeft);
    (0, useOnAddLabel_1.useOnAddLabel)(selectedToolType, setIsAddingLabels);
    const handleToolTypeChange = (type) => {
        setSelectedToolType(type);
    };
    const onClear = () => {
        labelToolManager === null || labelToolManager === void 0 ? void 0 : labelToolManager.setLabelsState([]);
        labelToolManager === null || labelToolManager === void 0 ? void 0 : labelToolManager.updateUndoRedoHistory();
        labelToolManager === null || labelToolManager === void 0 ? void 0 : labelToolManager.resetGroupMode();
        localStorage.removeItem('groupModeID');
    };
    (0, react_1.useEffect)(() => {
        bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
            type: selectedToolType,
            currentOptions: { type: selectedToolType },
        });
    }, [bridge, selectedToolType]);
    return ((0, jsx_runtime_1.jsxs)(ToolsMode_1.default, { title: (labelsState === null || labelsState === void 0 ? void 0 : labelsState.isGroupMode) ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, i18n_1.Localized)(i18n_1.Strings.tools.labels.clickOn), ' ', (0, i18n_1.Localized)(i18n_1.Strings.tools.labels.groupLabel)] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, i18n_1.Localized)(i18n_1.Strings.tools.labels.clickOn), ' ', (0, i18n_1.Localized)(i18n_1.Strings.tools.labels.title)] })), clearTitle: (0, i18n_1.Localized)(i18n_1.Strings.tools.labels.clear), doneTitle: (labelsState === null || labelsState === void 0 ? void 0 : labelsState.isGroupMode)
            ? (0, i18n_1.Localized)(i18n_1.Strings.common.save)
            : (0, i18n_1.Localized)(i18n_1.Strings.tools.header.done), onToggleUI: toggleUIHidden, selectedType: selectedToolType, isGroupMode: labelsState === null || labelsState === void 0 ? void 0 : labelsState.isGroupMode, isClearActive: ((_b = labelsState === null || labelsState === void 0 ? void 0 : labelsState.labels) === null || _b === void 0 ? void 0 : _b.length) > 0, onClear: onClear, isAddingLabels: isAddingLabels, setIsAddingLabels: setIsAddingLabels, "data-e2e": 'ToolLabelsModePage_ToolsModeTemplate', children: [(0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isGuidesButtonVisible, timeout: 300, mountOnEnter: true, unmountOnExit: true, appear: true, "data-e2e": 'ToolLabelsModePage_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledGuidesButton, { "data-e2e": 'ToolLabelsModePage_StyledGuidesButton' }) }), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: !isUIHidden, timeout: 300, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'ToolLabelsModePage_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledToolsLabelsOptionsPanel, { type: selectedToolType, onToolTypeChange: handleToolTypeChange, "data-e2e": 'ToolLabelsModePage_StyledToolsLabelsOptionsPanel' }) })] }));
}
exports.default = ToolLabelsModePage;
const StyledToolsLabelsOptionsPanel = (0, styled_components_1.default)(LabelsOptionsPanel_1.default) `
  position: absolute;
  bottom: 20px;
  left: calc(50% - 70px);

  ${(0, animation_1.SlideDown)('130%')}
`;
const StyledGuidesButton = (0, styled_components_1.default)(GuidesButton_1.default) `
  position: absolute;
  bottom: 20px;
  left: 15px;

  ${(0, animation_1.SlideDown)('130%')}
`;
